import React, { useEffect, useState } from "react";
import notify from "../Notify/notify";
import fnbplaceholder from "../../assets/images/f&bplaceholder.jpeg"

const FNBListView = (props) => {
  const { item, orderedFnbList, navigate, date,decFnb, addFnb } = props;
  const [fNBId, setFNBId] = useState("");
  const [num, setNum] = useState(0);
  const [selectedfNBList, setSelectedFNBList] = useState(item);

  const incNum = () => {
    if (item?.quantity) {
      setNum(Number(item?.quantity) + 1);
    }
  };
  const decNum = () => {
    if (item?.quantity > 0) {
      setNum(item?.quantity - 1);
    }
  };
  const handleChange = (e) => {
    setNum(e.target.value);
  };



  return (
    <>
      <div className="add-listing-box-inner">
        <div className="add-listing-left">
          <div
            className={
              item?.is_veg == 1 ? "selected-box active" : "selected-box"
            }
          >
            <p className="selected-box-inner"></p>
          </div>
          <p>{item?.name}</p>
          <p>Rs {item?.price}</p>
        </div>
        <div className="add-listing-right">
          <img
            src={item?.image_url == "" ? fnbplaceholder : item?.image_url}
            alt="cookies"
            className="add-listing-img"
          />
          {item?.quantity > 0 ? (
            <p className="addcart-text">
              <span className="add-dencrease">
                <a
                  onClick={() => {
                    decNum();
                    
                    decFnb(item)
                  }}
                >
                  <i className="fa fa-minus"></i>
                </a>
              </span>
              {item?.quantity}
              <span className="add-increase">
                <a
                  onClick={() => {
                      incNum();
                      addFnb(item)
                  }}
                >
                  <i className="fa fa-plus"></i>
                </a>
              </span>
            </p>
          ) : (
            <a
              className="addcart-text"
              onClick={() => {
                setNum(1);
                addFnb(item)
              }}
            >
              ADD
            </a>
          )}
        </div>
      </div>
    </>
  );
};

export default FNBListView;
